module.exports = "img/flags/AZ.97a37a9.png";